import { h } from '@seahax/elemental';

import { define } from '../utils/define.ts';
import style from './title.css?inline';

export const Title = define(
  (shadow) => {
    h(shadow, [
      h('h1', { class: 'title-heading' }, [
        h('span', { class: 'title-left' }, ['Sea']),
        h('span', { class: 'title-right' }, ['hax']),
      ]),
    ]);
  },
  { tagName: 'ce-title', styles: [style] },
);
